import { DATE_FORMATS } from "shared/dateUtils";
import type { EnrichedAnimalCategory } from "shared/types";
import type { CategoryFilterFormState } from "../category.types";

export const MIN_CONCILIATION_DATE = "17/08/2021" as const;
export const CONCILIATION_DATE_PICKER_FORMAT = DATE_FORMATS["MM/DD/YYYY"];
export const WARNING_ICON_PATH = "../images/ic_warning_outlined.svg";
export const RED_INFO_ICON_PATH = "../images/ic-infoRed.svg";

export enum CategoryStatusFilter {
  All = 0,
  Active = 1,
  Inactive = 2,
}

export enum WeightGainCurveFilter {
  All = 0,
  Yes = 1,
  No = 2,
}

export enum CategoryGender {
  Male = "M",
  Female = "F",
}

export enum CategoryListTableColumn {
  Name = "name",
  AmountForConciliation = "amount-for-conciliation",
  LotSize = "lot-size",
  Gender = "gender",
  AgeRange = "age-range",
  WeightGainCurve = "weight-gain-curve",
  Edit = "edit",
  Status = "status",
}

function isFilteredByName(categoryName: string, searchText: string): boolean {
  if (searchText.trim() === "") {
    return true;
  }

  return categoryName.toUpperCase().includes(searchText.trim().toUpperCase());
}

function isFilteredByStatus(
  deletionUser: string | null,
  deletedAt: string | null,
  filter: CategoryStatusFilter
): boolean {
  if (filter === CategoryStatusFilter.All) {
    return true;
  }

  if (filter === CategoryStatusFilter.Active) {
    return deletionUser == null && deletedAt == null;
  }

  return deletionUser != null || deletedAt != null;
}

function isFilteredByWeightGainCurve(
  weightGainCurveId: number | null,
  filter: WeightGainCurveFilter
): boolean {
  if (filter === WeightGainCurveFilter.All) {
    return true;
  }

  if (filter === WeightGainCurveFilter.Yes) {
    return weightGainCurveId != null;
  }

  return weightGainCurveId == null;
}

export function filterCategoryPredicate(
  category: EnrichedAnimalCategory,
  filterForm: CategoryFilterFormState
): boolean {
  const matchesSearchText = isFilteredByName(
    category.name,
    filterForm.searchText
  );

  const matchesStatus = isFilteredByStatus(
    category.deletionUser,
    category.deletedAt,
    filterForm.categoryStatus
  );

  const matchesWeightGainCurve = isFilteredByWeightGainCurve(
    category.weightGainCurveId,
    filterForm.weightGainCurveFilter
  );

  return matchesSearchText && matchesStatus && matchesWeightGainCurve;
}
